import * as Sentry from "@sentry/react";

export const reportFrontendErrorForInvestigation = (error: any) => {
  console.error(error);
  Sentry.captureException(error);
};
